<template>
  <div class="container" ref="container">
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="true"
    ></b-loading>
    <div
      v-for="department in departments"
      :key="department.id"
      class=""
      ref="container"
    >
      <div class="columns">
        <div class="column is-6">
          <h1 class="title">{{ department.name }}</h1>

          <p>{{ department.address1 }}</p>
          <p v-if="department.address2 != ''">{{ department.address2 }}</p>
          <p>{{ department.zip }} {{ department.city }}</p>
          <p>{{ department.phoneNumber }}</p>
          <p>
            <a :href="`mailto: ${department.email}`">{{ department.email }}</a>
          </p>
        </div>
        <div class="column is-6">
          <div class="map-responsive">
            <iframe
              :id="`${department.id}`"
              width="100%"
              height="450"
              frameborder="0"
              style="border:0;"
              :src="
                `https://www.google.com/maps/embed/v1/place?key=AIzaSyDdVhh6dCJw1aSbIRUbKFiGaUwEgkeCEo0&q=${department.address1}, ${department.zip} ${department.city}`
              "
            >
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      departments: null,
      isLoading: true,
    };
  },

  mounted() {
    this.$axios
      .get(`${window.apiURL}/locations`)
      .then((response) => {
        this.isLoading = false;
        this.departments = response.data;
      })
      .catch((error) => {
        this.isLoading = false;
        this.errorMessage = error.response.data.message
          ? error.response.data.message
          : error.message;
      });
  },
};
</script>

<style lang="scss">
.map-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;

  iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }
}
</style>
